import Vue from "vue";

export default new Vue({
  computed: {
    eventName(): string {
      return 'clear-list-view-filters';
    },
  },
  methods: {
    emitEvent(...args: any[]): void {
      this.$emit(this.eventName);
    },
    onEvent(callback: Function): void {
      this.$on(this.eventName, callback);
    },
    offEvent(callback: Function): void {
      this.$off(this.eventName, callback);
    },
  },
});